import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { Badge } from '@scramble/ui';
import type { NavItemProps } from '../types';
import s from './index.module.scss';

export const NavItem = ({ item }: NavItemProps): JSX.Element => {
  const Icon = item.icon;
  return (
    <NavLink
      to={item.path}
      className={({ isActive }) => classnames(s.item, isActive && s.item_active)}
    >
      <div className={s.icon}>
        <Icon />
        {item.hasNotifications && <span className={s.icon_badge} />}
      </div>
      <span className={classnames(s.label, 'f-body-sm f-500')}>{item.label}</span>
      {item.isNew && <Badge label="New" type="success" size="small" />}
    </NavLink>
  );
};
